import React from "react";
import Image from "next/image";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import TimerIcon from "@mui/icons-material/Timer";
// import VerifiedIcon from "@mui/icons-material/Verified";
import dynamic from "next/dynamic";
import { HOME_IMAGE, ABOUT_PREFIX } from "../data";

const ContentLayoutFooterNoChartreuse = dynamic(
  () => import("../components/Layout/ContentLayoutFooterNoChartreuse"),
);

function About() {
  const handleContextMenu = (event: React.MouseEvent<HTMLImageElement>) => {
    event.preventDefault();
  };
  const handleDragStart = (event: React.DragEvent<HTMLImageElement>) => {
    event.preventDefault();
  };
  return (
    <ContentLayoutFooterNoChartreuse title="About">
      <div
        onContextMenu={handleContextMenu}
        className="relative overflow-hidden h-[55vh]"
      >
        <Image
          className="w-screen h-screen overflow-hidden object-cover items-center justify-center"
          //
          sizes="(max-width: 3840px) 100vw"
          width={500}
          height={500}
          priority
          src={HOME_IMAGE}
          alt=""
        />

        {/* Top wavy SVG */}
        <svg
          className="absolute inset-x-0 top-0 h-1/6 w-screen"
          viewBox="100 0 1000 100"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* First wave */}
          <path
            fill="#FFFFFF"
            d="M0 33C240 90 480 10 720 33C960 57 1200 -20 1440 33V0H0V33Z"
          />

          {/* Second wave */}
          <path
            fill="#FFFFFF"
            d="M0 50C240 90 480 60 720 50C960 40 1200 90 1440 50V15H0V50Z"
          />
        </svg>

        {/* Bottom wavy SVG */}
        <svg
          className="absolute inset-x-0 bottom-0 h-1/6 w-screen"
          viewBox="-100 0 1000 100"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* First wave */}
          <path
            fill="#FFFFFF"
            transform="translate(1000, 100) scale(-1, -1)"
            d="M0 33C240 90 480 10 720 33C960 57 1200 -20 1440 33V0H0V33Z"
          />

          {/* Second wave */}
          <path
            fill="#FFFFFF"
            transform="translate(1000, 100) scale(-1, -1)"
            d="M0 50C240 90 480 60 720 50C960 40 1200 90 1440 50V15H0V50Z"
          />
        </svg>
        {/* <div className="absolute inset-0 flex flex-col items-center justify-center top-[33vh]">
          <h1 className="text-white text-6xl text-center tracking-wide mb-3">
            design with intelligence.
          </h1>
        </div> */}
      </div>
      <h1 className="text-black text-4xl md:text-6xl text-center tracking-wide pt-10 pb-6 md:pt-16 md:pb-12">
        AI-Powered Art Studio
      </h1>
      <div className="flex flex-col mb-16 justify-evenly">
        {/* Icon and Description 1 */}
        <div className="relative flex justify-center md:items-center md:mt-16 md:mb-16 mt-16 mb-4 lg:px-12">
          <div className="flex flex-row md:mx-8 mx-8">
            <Image
              className="block md:hidden lg:hidden" // Visible on small screens, hidden on medium screens and above
              src="/home/Createmobile.png"
              alt="Create Framed Art"
              width={400}
              height={400}
            />
            <Image
              className="hidden md:block lg:hidden" // Hidden on small and large screens, visible on medium screens
              src="/home/Create.png"
              alt="Create Framed Art"
              width={1200}
              height={1200}
            />
            <Image
              className="hidden md:hidden lg:block" // Hidden on small and medium screens, visible on large screens and above
              src="/home/Createlarge.png"
              alt="Create Framed Art"
              width={2000}
              height={2000}
            />
          </div>
          <div className="absolute flex flex-col w-2/3 md:w-1/2 text-center items-center justify-center mx-4 pt-6 md:p-24 md:transform md:translate-x-[-12em] max-w-[300px] md:max-w-[600px] lg:transform lg:translate-x-0">
            <span className="text-3xl md:text-4xl font-bold text-black">
              Create
            </span>
            <p className="text-l md:text-xl text-black mt-4">
              Custom art that does not exist anywhere in the world until you
              create it.
            </p>
          </div>
        </div>
        {/* Icon and Description 2 */}
        <div className="relative flex justify-center md:justify-center md:items-center md:my-16 my-4 lg:px-12">
          <div className="flex flex-row md:mx-8 mx-8">
            <Image
              className="block md:hidden lg:hidden" // Visible on small screens, hidden on medium screens and above
              src="/home/Framemobile.png"
              alt="Create Framed Art"
              width={400}
              height={400}
            />
            <Image
              className="hidden md:block lg:hidden" // Hidden on small screens, visible on medium screens and above
              src="/home/Frame.png"
              alt="Create Framed Art"
              width={1200}
              height={1200}
            />
            <Image
              className="hidden md:hidden lg:block" // Hidden on small screens, visible on medium screens and above
              src="/home/Framelarge.png"
              alt="Create Framed Art"
              width={2000}
              height={2000}
            />
          </div>
          <div className="absolute flex flex-col w-2/3 md:w-1/2 text-center items-center justify-center mx-4 pt-6 md:p-24 md:transform md:translate-x-[-12em] max-w-[200px] md:max-w-[500px] lg:transform lg:translate-x-0">
            <span className="text-3xl md:text-4xl font-bold text-black">
              Frame
            </span>
            <p className="text-l md:text-xl text-black mt-4">
              Print, frame and mount to meet museum standards.
            </p>
          </div>
        </div>
        {/* Icon and Description 3 */}
        <div className="relative flex justify-center md:items-center md:mt-16 md:mb-16 my-4 lg:px-12">
          <div className="flex flex-row md:mx-8 mx-8">
            <Image
              className="block md:hidden lg:hidden" // Visible on small screens, hidden on medium screens and above
              src="/home/Finishmobile.png"
              alt="Create Framed Art"
              width={400}
              height={400}
            />
            <Image
              className="hidden md:block lg:hidden" // Hidden on small screens, visible on medium screens and above
              src="/home/Finish.png"
              alt="Create Framed Art"
              width={1200}
              height={1200}
            />
            <Image
              className="hidden md:hidden lg:block" // Hidden on small screens, visible on medium screens and above
              src="/home/Finishlarge.png"
              alt="Create Framed Art"
              width={2000}
              height={2000}
            />
          </div>
          <div className="absolute flex flex-col w-2/3 md:w-1/2 text-center items-center justify-center mx-4 pt-6 md:p-24 md:transform md:translate-x-[-12em] max-w-[200px] md:max-w-[500px] lg:transform lg:translate-x-0">
            <span className="text-3xl md:text-4xl font-bold text-black">
              Finish
            </span>
            <p className="text-l md:text-xl text-black mt-4">
              Assembled and shipped to your door in 2-weeks.
            </p>
          </div>
        </div>
      </div>
      {/* Co-Founder Section */}
      <div className="flex flex-col justify-center items-center pt-4 bg-white" />
      <h1 className="flex justify-center items-center text-4xl py-8 mb-4">
        Team
      </h1>
      <div
        onContextMenu={handleContextMenu}
        onDragStart={handleDragStart}
        className="flex flex-col md:flex-row justify-center"
      >
        <div className="flex justify-center md:w-1/3">
          <div className="flex flex-col items-center">
            <Image
              src={`${ABOUT_PREFIX}2520bb8e-0678-4d2f-bce3-89a3bbbf2082.png`}
              alt="Artwork"
              width={500}
              height={500}
              className="flex drop-shadow-lg w-[70%] rounded-xl"
            />
            <div className="mt-4 w-[68%]">
              <ul className="text-sm">
                <li>
                  Title: <em>Origami</em>
                </li>
                <li>Elements: Geometric, Minimalism</li>
                <li>East Hampton, NY | 2023</li>
                <br />
              </ul>
            </div>
            <div className="w-[68%] pb-8">
              <p>by</p>
              <h2 className="font-bold">Dennis McGovern</h2>
              <ul className="text-sm">
                <li>Co-Founder</li>
                <li>
                  Cloud-based SaaS growth and revenue operator. Impatient and
                  has issues with authority. Previously @ Spot.io (NASDAQ:
                  NTAP), CloudBees and Liaison (NASDAQ: OTEX).
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-center md:w-1/3">
          <div className="flex flex-col items-center">
            <Image
              src={`${ABOUT_PREFIX}76e18736-1d47-450d-afa2-3a27bc6c1cec.png`}
              alt="Artwork"
              width={500}
              height={500}
              className="flex drop-shadow-lg w-[70%] rounded-xl"
            />
            <div className="mt-4 w-[68%]">
              <ul className="text-sm">
                <li>
                  Title: <em>A Blue Mystery</em>
                </li>
                <li>Elements: Watercolor, Sky</li>
                <li>Brooklyn, NY | 2023</li>
                <br />
              </ul>
            </div>
            <div className="w-[68%] pb-8">
              <p>by</p>
              <h2 className="font-bold">Jimmy McNider</h2>
              <ul className="text-sm">
                <li>Co-Founder</li>
                <li>
                  Media, art, and e-commerce entrepreneur, passionate about
                  building consumer tech products. Previously @ Spacey, IAC, &
                  Propagate Content.
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-center md:w-1/3">
          <div className="flex flex-col items-center">
            <Image
              src={`${ABOUT_PREFIX}9d51cc04-c663-483f-a199-6797934fc521_mgsb9z.png`}
              alt="Artwork"
              width={500}
              height={500}
              className="flex drop-shadow-lg w-[70%] rounded-xl"
            />
            <div className="mt-4 w-[68%]">
              <ul className="text-sm">
                <li>
                  Title: <em>Gold Splash</em>
                </li>
                <li>Elements: Organic, Sky</li>
                <li>San Francisco, CA | 2023</li>
                <br />
              </ul>
            </div>
            <div className="w-[68%] pb-8">
              <p>by</p>
              <h2 className="font-bold">Steven Feltner</h2>
              <ul className="text-sm">
                <li>Co-Founder</li>
                <li>
                  Engineer with a deep passion for exploring and mastering the
                  ever-evolving world of technology. Previously @ Spot.io
                  (NASDAQ: NTAP)
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Advisors Section */}
      <div className="flex flex-col justify-center items-center pt-4 bg-white" />
      <div
        onContextMenu={handleContextMenu}
        onDragStart={handleDragStart}
        className="flex flex-col md:flex-row justify-center"
      >
        <div className="flex justify-center md:w-1/3">
          <div className="flex flex-col items-center">
            <Image
              src={`${ABOUT_PREFIX}bab31810-ecba-43ee-a28e-ba6c96ef34be.png`}
              alt="Artwork"
              width={500}
              height={500}
              className="flex drop-shadow-lg w-[70%] rounded-xl"
            />
            <div className="mt-4 w-[68%]">
              <ul className="text-sm">
                <li>
                  Title: <em>Neon Bouquet</em>
                </li>
                <li>Elements: Bauhaus, Flowers</li>
                <li>Brooklyn, NY | c. 2023</li>
                <br />
              </ul>
            </div>
            <div className="w-[68%] pb-8">
              <p>by</p>
              <h2 className="font-bold">Alex Covington</h2>
              <ul className="text-sm">
                <li>Advisor</li>
                <li>
                  Brand and community builder. Home design vision-boarder.
                  Previous works of art @ The Wing, Getaway, and Delta.
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-center md:w-1/3">
          <div className="flex flex-col items-center">
            <Image
              src={`${ABOUT_PREFIX}IMG_2422-aMEJO9yj4_jrrcmn.png`}
              alt="Artwork"
              width={500}
              height={500}
              className="flex drop-shadow-lg w-[70%] rounded-xl"
            />
            <div className="mt-4 w-[68%]">
              <ul className="text-sm">
                <li>
                  Title: <em>Dadada</em>
                </li>
                <li>Elements: Dadaism, Warm</li>
                <li>New York, NY | c. 2023</li>
                <br />
              </ul>
            </div>
            <div className="w-[68%] pb-8">
              <p>by</p>
              <h2 className="font-bold">Jeremiah Evarts</h2>
              <ul className="text-sm">
                <li>Advisor</li>
                <li>
                  Art Historian working at the intersection of history and the
                  fickle art market. Nerd for Cubism. Currently: Deputy Chairman
                  and Specialist in 20th Century and Contemporary Art at
                  Phillips Auction House.
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-center md:w-1/3">
          <div className="flex flex-col items-center">
            <Image
              src={`${ABOUT_PREFIX}dece9a34-4151-43d3-ae98-258ec18bf69b.png`}
              alt="Artwork"
              width={500}
              height={500}
              className="flex drop-shadow-lg w-[70%] rounded-xl"
            />
            <div className="mt-4 w-[68%]">
              <ul className="text-sm">
                <li>
                  Title: <em>Luminescent Labrinth</em>
                </li>
                <li>Elements: Organic, Orphism</li>
                <li>Los Angeles, CA | c. 2023</li>
                <br />
              </ul>
            </div>
            <div className="w-[68%] pb-8">
              <p>by</p>
              <h2 className="font-bold">Drew Shackleton</h2>
              <ul className="text-sm">
                <li>Advisor</li>
                <li>
                  Strategy and analytics leader in media and D2C. Previously @
                  Deloitte, Disney, and Sony. Currently: Paramount Global and
                  teaching at USC.
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-center md:w-1/3">
          <div className="flex flex-col items-center">
            <Image
              src={`${ABOUT_PREFIX}532c88a6-6a3c-4e99-aec6-9ca94eda577c.png`}
              alt="Artwork"
              width={500}
              height={500}
              className="flex drop-shadow-lg w-[70%] rounded-xl"
            />
            <div className="mt-4 w-[68%]">
              <ul className="text-sm">
                <li>
                  Title: <em>Blushed</em>
                </li>
                <li>Elements: Minimalism, Watercolor</li>
                <li>New York, NY | c. 2023</li>
                <br />
              </ul>
            </div>
            <div className="w-[68%] pb-8">
              <p>by</p>
              <h2 className="font-bold">Megan Stein</h2>
              <ul className="text-sm">
                <li>Advisor</li>
                <li>
                  Writer, editor, and leader in the digital Home and Lifestyle
                  space. Expert at online shopping. Previously @ Hearst and
                  Dotdash Meredith.
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-center md:w-1/3">
          <div className="flex flex-col items-center">
            <Image
              src={`${ABOUT_PREFIX}akldjlkjflkslkdjflakjslkdflksdf_hkpcvd.png`}
              alt="Artwork"
              width={500}
              height={500}
              className="flex drop-shadow-lg w-[70%] rounded-xl"
            />
            <div className="mt-4 w-[68%]">
              <ul className="text-sm">
                <li>
                  Title: <em>Dancing Class</em>
                </li>
                <li>Elements: Abstract, Energetic</li>
                <li>New York, NY | c. 2023</li>
                <br />
              </ul>
            </div>
            <div className="w-[68%] pb-8">
              <p>by</p>
              <h2 className="font-bold">Shabih Syed</h2>
              <ul className="text-sm">
                <li>Advisor</li>
                <li>
                  Growth Product Executive specializing in rapid business scale
                  through user-friendly products and data-driven strategies.
                  Currently: Square.
                </li>
                <br />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
}

export default About;

export async function getStaticProps() {
  return {
    props: { page: "About" },
  };
}
